import React, { Component } from 'react';
import { Spin } from 'antd';
import CommonCharts from '../../../components/Charts';
import Fetch from '../../../../../common/Fetch';
import ExportUtil from '../../../../../common/ExportUtil';

const GraphicType = 1;
const Unit = ['单位：万元'];

class  HistogramChart extends Component {
    constructor(props) {
        super(props);
        const { title } = props;
        this.isBA = title === 'BA';
        this.state = {
            data: [],
            loading: false,
        };
    }

    shouldComponentUpdate(nextProps, nextState) {
        const { searchParams: nextSearchParams } = nextProps;
        const { searchParams } = this.props;
        if (nextSearchParams !== searchParams) {
            return false;
        }
        return true;
    }

    componentDidMount() {
        this.loadData();
    }
    
    componentDidUpdate(prevProps) {
        if (prevProps.load !== this.props.load) {
            this.loadData();
        }
    }

    loadData = () => {
        const { searchParams, queryUrl, countType } = this.props;

        this.setState({ loading: true });
        Fetch.post(queryUrl, {
            countType,
            GraphicType,
            ...searchParams,
        }).then(res => {
            const { data, externalData } = res;
            this.setState({
                data: this.isBA ? externalData : data,
                loading: false,
            });
        }).catch(err => {
            console.error(err);
            this.setState({ loading: false });
        });
    }

    handleClick = () => {
        const { searchParams, exportUrl, countType } = this.props;
        ExportUtil.export({ ...searchParams, countType, GraphicType }, null, exportUrl);
    }

    render() {
        const { title, height, chartTitle, filename, searchParams } = this.props;
        const { data, loading } = this.state;
        const { type } = searchParams;
        const categories = [];
        const chartData = (data || []).map((item, index) => {
            const { remittanceAmountTotalDataRounding, condition } = item;
            const number = index + 1;
            categories.push(this.isBA ? condition : number);
            return {
                number,
                condition,
                y: Number(remittanceAmountTotalDataRounding),
            };
        });

        let legendSetting = {};
        if (!this.isBA) {
            let legendContent = '';
            chartData.forEach(i => legendContent += `<p title="${i.condition}" style="overflow:hidden;text-overflow:ellipsis;white-space:nowrap">${i.number}: ${i.condition}</p>`);
            legendSetting.useHTML = true;
            legendSetting.labelFormatter = function () {
                return legendContent;
            };
        }
        return (
            <div className="chart-content">
                <Spin spinning={loading}>
                    <p className="chart-title">{title}({chartTitle})</p>
                    <CommonCharts
                        type='column'
                        height={height}
                        filename={filename}
                        xAxis={{categories}}
                        yAxis={{
                            title: {
                                text: Unit[type],
                            },
                        }}
                        legend={{
                            squareSymbol: false,
                            symbolHeight: 0,
                            symbolWidth: 0,
                            ...legendSetting
                        }}
                        plotOptions={{
                            column: {
                                allowPointSelect: true,
                                cursor: 'pointer',
                                colorByPoint: true,
                                colors: ["#6b95f2"],
                                dataLabels: {
                                    enabled: true,
                                    format: '{point.y}',
                                    style: { color: 'black', textOutline: 'none' },
                                },
                                tooltip: {
                                    headerFormat: '',
                                    pointFormat: '<b>{point.number}</b>: {point.condition} {point.y}',
                                },
                                showInLegend: true
                            }
                        }}
                        series={[{
                            name: chartTitle,
                            data: chartData
                        }]}
                        onClick={this.handleClick}
                    />
                </Spin>
            </div>
        );
    }
}

export default  HistogramChart;


// WEBPACK FOOTER //
// ./src/components/RequestDataAnalysis/RequestToDo/components/ChartsCollection/HistogramChart.js